import { Contaner } from "./styled";
import Logo from "../../../../assets/img/Langding/Logo.svg";

const AboutUs = () => {
  return (
    <Contaner>
      <img src={Logo} alt="" />
      <h1>ABOUT US</h1>
      <p>
        At Green Foundation, our goal is to leverage blockchain technology to
        facilitate the connection between private forest owners and
        environmental advocates, working together towards reforestation and a
        more sustainable future.
      </p>
      <p>
        The Green Foundation is an innovative environmental crypto project that
        connects private forest owners with environmental advocates to
        facilitate tree-planting and reforestation efforts.
      </p>
      <p>
        Join us in our efforts to make a positive impact on the environment by
        supporting reforestation projects.
      </p>
    </Contaner>
  );
};
export default AboutUs;
